import React, { useRef } from 'react';
import { Building2Icon, HomeIcon } from 'lucide-react';
import type { Market } from '../types/content';
type MarketTabsProps = {
  value: Market;
  onChange: (market: Market) => void;
  idPrefix: string;
  label: string;
  labels: Record<Market, string>;
};
const markets: Market[] = ['commercial', 'residential'];
const icons = {
  commercial: Building2Icon,
  residential: HomeIcon
};
export function MarketTabs({
  value,
  onChange,
  idPrefix,
  label,
  labels
}: MarketTabsProps) {
  const refs = useRef<Record<Market, HTMLButtonElement | null>>({
    commercial: null,
    residential: null
  });
  const onKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Home' && e.key !== 'End') return;
    e.preventDefault();
    const next: Market = value === 'commercial' ? 'residential' : 'commercial';
    onChange(next);
    refs.current[next]?.focus();
  };
  return <div role="tablist" aria-label={label} className="inline-flex w-full rounded-xl bg-mist p-1.5 ring-1 ring-line sm:w-auto" data-id="element-261" data-mp="1d5spynit09a6">
      {markets.map(m => {
      const active = m === value;
      const Icon = icons[m];
      return <button key={m} ref={el => {
        refs.current[m] = el;
      }} type="button" role="tab" id={`${idPrefix}-tab-${m}`} aria-selected={active} aria-controls={`${idPrefix}-panel`} tabIndex={active ? 0 : -1} onClick={() => onChange(m)} onKeyDown={onKeyDown} className={`flex min-h-[52px] flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-lg px-4 font-display text-sm font-bold transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy sm:flex-none sm:px-6 sm:text-[15px] ${active ? 'bg-navy text-white shadow-sm' : 'text-body hover:text-navy'}`} data-id="element-262" data-mp="3srjw5l5v5pmi">
            <Icon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-263" data-mp="1bj8e30qac2ps" />
            {labels[m]}
          </button>;
    })}
    </div>;
}